import { PlatformUtility } from 'utility-ts-platform';

export interface IModalData {
  title: string;
  content: string;
}

export class PlacementTestTileModalController {
  private isOpen: boolean = false;
  private isMobile: boolean = false;
  private modalData: IModalData;

  constructor() {
    this.isMobile = PlatformUtility.isMobile();
  }

  hideModal() {
    this.isOpen = false;
  }
}
export class PlacementTestTileModalComponent implements angular.IComponentOptions {
  public templateUrl: string = 'biz-ng-path-placement/src/modals/placement_test_tile_modal.html';
  public controller: any = PlacementTestTileModalController;
  public bindings: any = {
    modalData: '<',
    isOpen: '='
  };
}



// WEBPACK FOOTER //
// ./app/vendor/biz-ng-path-placement/src/modals/placement_test_tile_modal.ts